import { Box } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { forwardRef, useImperativeHandle } from "react";

const Snackbar = forwardRef((props, ref) => {
  const { enqueueSnackbar } = useSnackbar();

  useImperativeHandle(ref, () => ({
    openSnack(snackMessage, snackType = "default") {
      if (!snackMessage || typeof snackMessage !== "string") {
        console.error("Snackbar message must be a string");
        return;
      }

      if (
        !["default", "error", "success", "warning", "info"].includes(snackType)
      ) {
        console.error("Invalid snackbar type:", snackType);
        snackType = "default";
      }

      enqueueSnackbar(snackMessage, { variant: snackType });
    },
  }));

  return <Box />;
});

export default Snackbar;
